import React from 'react';
import { useTranslation } from 'react-i18next';
import Skeleton from 'react-loading-skeleton';
import { useGetCurrentAccountUser } from 'routes/screens/settings/hooks';

type CreatedByType = {
  userId: string;
};

const CreatedBy = (props: CreatedByType) => {
  const { t } = useTranslation();
  const { userId } = props;
  const { data: userData, isLoading } = useGetCurrentAccountUser(userId);
  const userName = `${userData?.user?.first_name || ''} ${
    userData?.user?.middle_name || ''
  } ${userData?.user?.last_name || ''}`.trim();
  const userEmail = userData?.user?.email || '';
  const createdBy =
    userName ||
    userEmail ||
    `${t('contacts.system')}` ||
    `${t('contacts.unknown_user')}`;

  return isLoading ? <Skeleton height={18} width={150} /> : <>{createdBy}</>;
};

export default CreatedBy;
